import { Routes, Route, Navigate } from "react-router-dom";
import TreydoraSiteShell from "./components/site/TreydoraSiteShell";
import Home from "./pages/Home/Home";
import { useEffect } from "react";
import WOW from "wow.js";
//import HomeTwo from "./pages/Home/HomeTwo";
import Blog from "./pages/Blog/Blog";
import LibraryPage from "./pages/Library/LibraryPage";
import LibraryAssetDetailPage from "./pages/Library/LibraryAssetDetailPage";
import LibraryPurchaseSuccessPage from "./pages/Library/LibraryPurchaseSuccessPage";
import MyLibraryPage from "./pages/Library/MyLibraryPage";
import LibraryReaderPage from "./pages/Library/LibraryReaderPage";
import MarketplaceHomePage from "./pages/Marketplace/MarketplaceHomePage";
import MarketplaceStorePage from "./pages/Marketplace/MarketplaceStorePage";
import MarketplaceProductPage from "./pages/Marketplace/MarketplaceProductPage";
import MyStorePage from "./pages/Marketplace/dashboard/MyStorePage";
/* Seller dashboard pages (setup, profile, products, editor, orders, payouts) are preserved on disk for a future
   functional phase; routes redirect to the visual preview hub during marketplace visual lockdown. */
import MarketplacePurchasesPage from "./pages/Marketplace/dashboard/MarketplacePurchasesPage";
import BlogDetailsPage from "./pages/BlogDetails/BlogDetailsPage";
import { useLocation } from "react-router-dom";
import ScrollToHashElement from "hashScroll";
import Profile from "./pages/Profile/Profile";
import ComicBook from "pages/Profile/comic";
import WorldOsharPage from "./pages/WorldOshar/WorldOsharPage";
import OsharRealEstatePage from "./pages/WorldOshar/OsharRealEstatePage";
import OsharRealEstateSuccessPage from "./pages/WorldOshar/OsharRealEstateSuccessPage";
import TreydoraGatewayDashboard from "./pages/Dashboard/TreydoraGatewayDashboard";
import QuestsPage from "./pages/Dashboard/QuestsPage";
import SupportCommandCenterPage from "./pages/Dashboard/SupportCommandCenterPage";
import ChroniclesPage from "./pages/Chronicles/ChroniclesPage";
import ChronicleDetailPage from "./pages/Chronicles/ChronicleDetailPage";
import LegalCenterPage from "./pages/Legal/LegalCenterPage";
import LegalDocumentPage from "./pages/Legal/LegalDocumentPage";
import PublicSupportPage from "./pages/Support/PublicSupportPage";
import LoginPage from "./pages/Auth/LoginPage";
import SignupPage from "./pages/Auth/SignupPage";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";

function App() {
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname, hash } = useLocation();
  useEffect(() => {
    const h = (hash || "").replace(/^#/, "").trim();
    if (!h) window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <>
      <ScrollToHashElement />
      <Routes>
        <Route element={<TreydoraSiteShell />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/" element={<Home />} />
          <Route path="/world" element={<WorldOsharPage />} />
          <Route path="/world/oshar" element={<WorldOsharPage />} />
          <Route path="/world/oshar/real-estate" element={<OsharRealEstatePage />} />
          <Route path="/world/oshar/real-estate/success" element={<OsharRealEstateSuccessPage />} />
          <Route path="/dashboard" element={<TreydoraGatewayDashboard />} />
          <Route path="/dashboard/quests" element={<QuestsPage />} />
          <Route path="/dashboard/support" element={<SupportCommandCenterPage />} />
          {/* Legacy dashboard help URL → unified Support Command Center (Phase 2F). */}
          <Route path="/dashboard/help" element={<Navigate to="/dashboard/support" replace />} />
          <Route path="/support" element={<PublicSupportPage />} />
          <Route path="/treydorex" element={<Navigate to={{ pathname: "/", hash: "sales" }} replace />} />
          <Route path="/token" element={<Navigate to={{ pathname: "/", hash: "sales" }} replace />} />
          <Route path="/token-sale" element={<Navigate to={{ pathname: "/", hash: "sales" }} replace />} />
          <Route path="/nft-comic" element={<Navigate to="/library" replace />} />
          <Route path="/treydora-comic" element={<Navigate to="/library" replace />} />
          <Route path="/novel" element={<Navigate to="/library" replace />} />
          <Route path="/book" element={<Navigate to="/library" replace />} />
          <Route path="/comic" element={<Navigate to="/library" replace />} />
          <Route path="/dashboard/library" element={<MyLibraryPage />} />
          <Route
            path="/dashboard/library-manager"
            element={<Navigate to="/library" replace />}
          />
          <Route path="/library/my" element={<Navigate to="/dashboard/library" replace />} />
          <Route path="/library/read/:assetSlug" element={<LibraryReaderPage />} />
          <Route path="/library/success" element={<LibraryPurchaseSuccessPage />} />
          <Route path="/home-two" element={<Home />} />
          <Route path="/chronicles" element={<ChroniclesPage />} />
          <Route path="/chronicles/:slug" element={<ChronicleDetailPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog-details" element={<BlogDetailsPage />} />
          <Route path="/explore" element={<Navigate to="/library" replace />} />
          <Route path="/library/:slug" element={<LibraryAssetDetailPage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/marketplace" element={<MarketplaceHomePage />} />
          <Route path="/marketplace/store/:storeSlug" element={<MarketplaceStorePage />} />
          <Route path="/marketplace/product/:productSlug" element={<MarketplaceProductPage />} />
          <Route path="/dashboard/my-store" element={<MyStorePage />} />
          <Route path="/dashboard/my-store/setup" element={<Navigate to="/dashboard/my-store" replace />} />
          <Route path="/dashboard/my-store/profile" element={<Navigate to="/dashboard/my-store" replace />} />
          <Route path="/dashboard/my-store/products" element={<Navigate to="/dashboard/my-store" replace />} />
          <Route path="/dashboard/my-store/products/new" element={<Navigate to="/dashboard/my-store" replace />} />
          <Route
            path="/dashboard/my-store/products/:productId/edit"
            element={<Navigate to="/dashboard/my-store" replace />}
          />
          <Route path="/dashboard/my-store/orders" element={<Navigate to="/dashboard/my-store" replace />} />
          <Route path="/dashboard/my-store/payouts" element={<Navigate to="/dashboard/my-store" replace />} />
          <Route path="/dashboard/my-store/*" element={<Navigate to="/dashboard/my-store" replace />} />
          <Route path="/dashboard/marketplace-purchases" element={<MarketplacePurchasesPage />} />
          <Route path="/item-detail" element={<Navigate to="/library" replace />} />
          <Route path="/item-detail/:id" element={<Navigate to="/library" replace />} />
          <Route path="/item-detail-unreleased/:id" element={<Navigate to="/library" replace />} />
          <Route path="/profile/:address" element={<Profile />} />
          <Route path="/profile/:address/comic/:id" element={<ComicBook />} />
          <Route path="/comic/:id" element={<ComicBook />} />
          <Route path="/legal" element={<LegalCenterPage />} />
          <Route path="/legal/:slug" element={<LegalDocumentPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
